module.exports = __webpack_public_path__ + "img/tick-xanh.a8d8d6fa.svg";